import { Fragment, useEffect, useState } from 'react';
import { useStoreSelector } from 'v3/data/store';
import { CountDownType } from 'v3/shared/components/Countdown/types';
import {
  COUNTDOWN_DURATION_MS,
  COUNTDOWN_INITIAL_TIME,
  COUNTER,
  EMAIL,
  MILISECS,
  SECS_PER_HOUR,
  SMS,
} from 'v3/shared/constants/countdown.constants';
import { TokenFormatEnum } from 'v3/shared/constants/token-type.enum';
import { BodySmallBold } from 'v3/shared/typography/BodySmall';
import { LabelSmall } from 'v3/shared/typography/LabelSmall';
import { TitleSmallBold } from 'v3/shared/typography/TitleSmall';
import { CountContainer, CustomLabelSmall, ResendContainer } from './styles';

export default function Countdown({ onResend, selectedMethod, onChangeMethod, count }: CountDownType) {
  const [totalTime, setTotalTime] = useState(COUNTDOWN_INITIAL_TIME);
  const { contractingKey } = useStoreSelector((store) => store.contracting);

  const minutes = Math.floor(totalTime / SECS_PER_HOUR);
  const seconds = totalTime % SECS_PER_HOUR;

  const generateTimeRemaing = (timeRecovered: number, now: number) => {
    return Math.ceil((COUNTDOWN_DURATION_MS - (now - timeRecovered)) / MILISECS);
  };

  const handleTimeOutReset = () => {
    onResend();
    setTotalTime(COUNTDOWN_INITIAL_TIME);
  };

  const handleInitCount = () => {
    const now = new Date().getTime();
    setTotalTime(generateTimeRemaing(count, now));
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTotalTime((prevTime) => {
        if (prevTime > 0) {
          return prevTime - COUNTER;
        }
        return 0;
      });
    }, MILISECS);

    return () => clearInterval(intervalId);
  }, [contractingKey]);

  useEffect(() => {
    handleInitCount();
  }, []);

  const oppositeMethod = selectedMethod === TokenFormatEnum.EMAIL ? SMS : EMAIL;

  if (!totalTime) {
    return (
      <Fragment>
        <ResendContainer onClick={handleTimeOutReset}>
          <TitleSmallBold>O código não chegou? Reenviar código</TitleSmallBold>
        </ResendContainer>
        <CustomLabelSmall onClick={() => onChangeMethod()}>Trocar envio para {oppositeMethod}</CustomLabelSmall>
      </Fragment>
    );
  }

  return (
    <CountContainer>
      <BodySmallBold>
        Reenviar o código em: {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
      </BodySmallBold>
      <LabelSmall>Aguarde o contador zerar para trocar o método de envio para {oppositeMethod}</LabelSmall>
    </CountContainer>
  );
}
